// extracted by mini-css-extract-plugin
module.exports = {"field":"_37x19IVYYPmn1hr23FmqRa","field__label":"_1IXCoekM6izSVSg3lU0JF4","field--horizontal":"_1WoKtaLwjGOgotZaE4W2ER","field__body":"_1QEod6NsXrKboWijyE7F_y"};